import AppLogo from '@Guidelines/Component/Brand/AppLogo';
import { theme } from '@Guidelines/Theme/theme';
import { css } from '@emotion/react';
import * as React from 'react';

type Props = {
	/** URL of the customer logo; `null` falls back to the application logo. */
	logo: string | null;
	tone: 'light' | 'dark';
	size: 'compact' | 'large';
};

const logoStyle = css`
	display: block;
	object-fit: contain;
`;

/** Any logo stands on a light plate when the surrounding surface is dark: the logo text is unreadable on dark. */
const plateStyle = css`
	display: inline-flex;
	align-items: center;
	background-color: ${theme.colors.surface};
	border-radius: ${theme.radii.medium};
	padding: 0.5rem 0.75rem;
`;

/** The identity shown in headers and on the login screen: the customer logo, or else the application logo alone. */
const BrandIdentity: React.FC<Props> = ({ logo, tone, size }) => {
	const isCompact = size === 'compact';

	const dimensionsStyle = React.useMemo(
		() => css`
			max-height: ${isCompact ? '32px' : '64px'};
			max-width: ${isCompact ? '160px' : '240px'};
		`,
		[isCompact],
	);

	if (logo !== null) {
		const image = <img src={logo} alt="" css={[logoStyle, dimensionsStyle]} />;
		return tone === 'dark' ? <span css={plateStyle}>{image}</span> : image;
	}

	const appLogo = <AppLogo variant={isCompact ? 'horizontal' : 'vertical'} height={isCompact ? 32 : 112} />;
	return tone === 'dark' ? <span css={plateStyle}>{appLogo}</span> : appLogo;
};

export default BrandIdentity;
